import { render, staticRenderFns } from "./evaluationTable.vue?vue&type=template&id=b4a612c2&scoped=true&"
import script from "./evaluationTable.vue?vue&type=script&lang=js&"
export * from "./evaluationTable.vue?vue&type=script&lang=js&"
import style0 from "./evaluationTable.vue?vue&type=style&index=0&id=b4a612c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a612c2",
  null
  
)

export default component.exports